import { render, staticRenderFns } from "./NhapKhoForm.vue?vue&type=template&id=0f3f9855&"
import script from "./NhapKhoForm.vue?vue&type=script&lang=js&"
export * from "./NhapKhoForm.vue?vue&type=script&lang=js&"
import style0 from "./NhapKhoForm.vue?vue&type=style&index=0&id=0f3f9855&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports